import React from "react";
import Title from "../home/Title";
import { blogImgOne, blogImgTwo, blogImgThree } from "../../assets";
import BlogCard from "./BlogCard";

const Blog = () => {
  return (
    <div>
      <Title title="Latest" subTitle="Conventions attended" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <BlogCard
            image={blogImgOne}
            title="October 16, 2020"
            subTitle="Oracle Convention Lisbon"
            category="Cloud"
          />
          <BlogCard
            image={blogImgTwo}
            title="October, 2022"
            subTitle="SQL performance"
            category="SQL"
          />
        </div>
        <div className="px-6">
          <BlogCard
            image={blogImgThree}
            title="September, 2021"
            subTitle="SQL Cloud"
            category="sql"
          />
          <BlogCard
            image={blogImgOne}
            title="March, 2022"
            subTitle="Oracle Apex technology"
            category="Apex"
          />
        </div>
      </div>
    </div>
  );
};

export default Blog;
